/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseCouncilDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseCouncilDetailDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponsePageCouncilDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseVoid } from '../backend/model';
// @ts-ignore
import type { CreateCouncilRequest } from '../backend/model';
// @ts-ignore
import type { UpdateCouncilRequest } from '../backend/model';
/**
 * CouncilApi - axios parameter creator
 * @export
 */
export const CouncilApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate a council to make it operational.
         * @summary Activate council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCouncil: async (councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('activateCouncil', 'councilId', councilId)
            const localVarPath = `/api/admin/councils/{councilId}/activate`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new council with the provided details.
         * @summary Create a new council
         * @param {CreateCouncilRequest} createCouncilRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouncil: async (createCouncilRequest: CreateCouncilRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCouncilRequest' is not null or undefined
            assertParamExists('createCouncil', 'createCouncilRequest', createCouncilRequest)
            const localVarPath = `/api/admin/councils`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouncilRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a council to stop its operations.
         * @summary Deactivate council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCouncil: async (councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('deactivateCouncil', 'councilId', councilId)
            const localVarPath = `/api/admin/councils/{councilId}/deactivate`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed information about a specific council.
         * @summary Retrieve council details
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncil1: async (councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncil1', 'councilId', councilId)
            const localVarPath = `/api/admin/councils/{councilId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a paginated list of councils with optional search and status filtering.
         * @summary Retrieve councils
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [search] 
         * @param {GetCouncilsStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncils: async (page?: number, size?: number, search?: string, status?: GetCouncilsStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/councils`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the details of an existing council.
         * @summary Update council
         * @param {number} councilId 
         * @param {UpdateCouncilRequest} updateCouncilRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncil1: async (councilId: number, updateCouncilRequest: UpdateCouncilRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('updateCouncil1', 'councilId', councilId)
            // verify required parameter 'updateCouncilRequest' is not null or undefined
            assertParamExists('updateCouncil1', 'updateCouncilRequest', updateCouncilRequest)
            const localVarPath = `/api/admin/councils/{councilId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouncilRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilApi - functional programming interface
 * @export
 */
export const CouncilApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate a council to make it operational.
         * @summary Activate council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateCouncil(councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateCouncil(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilApi.activateCouncil']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new council with the provided details.
         * @summary Create a new council
         * @param {CreateCouncilRequest} createCouncilRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCouncil(createCouncilRequest: CreateCouncilRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCouncil(createCouncilRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilApi.createCouncil']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate a council to stop its operations.
         * @summary Deactivate council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateCouncil(councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateCouncil(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilApi.deactivateCouncil']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed information about a specific council.
         * @summary Retrieve council details
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncil1(councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncil1(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilApi.getCouncil1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a paginated list of councils with optional search and status filtering.
         * @summary Retrieve councils
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [search] 
         * @param {GetCouncilsStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncils(page?: number, size?: number, search?: string, status?: GetCouncilsStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePageCouncilDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncils(page, size, search, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilApi.getCouncils']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the details of an existing council.
         * @summary Update council
         * @param {number} councilId 
         * @param {UpdateCouncilRequest} updateCouncilRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouncil1(councilId: number, updateCouncilRequest: UpdateCouncilRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouncil1(councilId, updateCouncilRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilApi.updateCouncil1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilApi - factory interface
 * @export
 */
export const CouncilApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilApiFp(configuration)
    return {
        /**
         * Activate a council to make it operational.
         * @summary Activate council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCouncil(councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.activateCouncil(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new council with the provided details.
         * @summary Create a new council
         * @param {CreateCouncilRequest} createCouncilRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouncil(createCouncilRequest: CreateCouncilRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilDTO> {
            return localVarFp.createCouncil(createCouncilRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a council to stop its operations.
         * @summary Deactivate council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCouncil(councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.deactivateCouncil(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed information about a specific council.
         * @summary Retrieve council details
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncil1(councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilDetailDTO> {
            return localVarFp.getCouncil1(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a paginated list of councils with optional search and status filtering.
         * @summary Retrieve councils
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [search] 
         * @param {GetCouncilsStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncils(page?: number, size?: number, search?: string, status?: GetCouncilsStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePageCouncilDTO> {
            return localVarFp.getCouncils(page, size, search, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the details of an existing council.
         * @summary Update council
         * @param {number} councilId 
         * @param {UpdateCouncilRequest} updateCouncilRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncil1(councilId: number, updateCouncilRequest: UpdateCouncilRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilDTO> {
            return localVarFp.updateCouncil1(councilId, updateCouncilRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilApi - object-oriented interface
 * @export
 * @class CouncilApi
 * @extends {BaseAPI}
 */
export class CouncilApi extends BaseAPI {
    /**
     * Activate a council to make it operational.
     * @summary Activate council
     * @param {number} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilApi
     */
    public activateCouncil(councilId: number, options?: RawAxiosRequestConfig) {
        return CouncilApiFp(this.configuration).activateCouncil(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new council with the provided details.
     * @summary Create a new council
     * @param {CreateCouncilRequest} createCouncilRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilApi
     */
    public createCouncil(createCouncilRequest: CreateCouncilRequest, options?: RawAxiosRequestConfig) {
        return CouncilApiFp(this.configuration).createCouncil(createCouncilRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a council to stop its operations.
     * @summary Deactivate council
     * @param {number} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilApi
     */
    public deactivateCouncil(councilId: number, options?: RawAxiosRequestConfig) {
        return CouncilApiFp(this.configuration).deactivateCouncil(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed information about a specific council.
     * @summary Retrieve council details
     * @param {number} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilApi
     */
    public getCouncil1(councilId: number, options?: RawAxiosRequestConfig) {
        return CouncilApiFp(this.configuration).getCouncil1(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a paginated list of councils with optional search and status filtering.
     * @summary Retrieve councils
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [search] 
     * @param {GetCouncilsStatusEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilApi
     */
    public getCouncils(page?: number, size?: number, search?: string, status?: GetCouncilsStatusEnum, options?: RawAxiosRequestConfig) {
        return CouncilApiFp(this.configuration).getCouncils(page, size, search, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the details of an existing council.
     * @summary Update council
     * @param {number} councilId 
     * @param {UpdateCouncilRequest} updateCouncilRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilApi
     */
    public updateCouncil1(councilId: number, updateCouncilRequest: UpdateCouncilRequest, options?: RawAxiosRequestConfig) {
        return CouncilApiFp(this.configuration).updateCouncil1(councilId, updateCouncilRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetCouncilsStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Suspended: 'SUSPENDED',
    Archived: 'ARCHIVED'
} as const;
export type GetCouncilsStatusEnum = typeof GetCouncilsStatusEnum[keyof typeof GetCouncilsStatusEnum];
